import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { PageHeader } from "@/components/portal/widgets";
import api, { inr } from "@/lib/api";

export default function Inventory() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/franchise/inventory").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const filtered = items.filter((i) => i.name.toLowerCase().includes(q.toLowerCase()));
  const badge = (i) => i.stock === 0 ? ["bg-red-100 text-red-700", "Out of stock"] : i.stock <= i.reorder_level ? ["bg-orange-100 text-orange-700", "Low"] : ["bg-yellow-200 text-yellow-700", "In stock"];

  return (
    <div className="animate-fade-up">
      <PageHeader title="Store Inventory" subtitle={`${items.length} SKUs tracked at your store.`} />
      <div className="relative max-w-sm mb-4">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input data-testid="inventory-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search items…" className="pl-9" />
      </div>
      <Card className="border-slate-200/80 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-muted-foreground bg-slate-50 dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
              <th className="py-3 px-4">Item</th><th className="py-3 px-4">Category</th><th className="py-3 px-4">Stock</th><th className="py-3 px-4">Reorder</th><th className="py-3 px-4">Price</th><th className="py-3 px-4">Status</th>
            </tr></thead>
            <tbody>
              {filtered.map((i) => {
                const [cls, label] = badge(i);
                return (
                  <tr key={i.id} data-testid={`inv-row-${i.id}`} className="border-b border-slate-100 dark:border-slate-800/50 hover:bg-slate-50 dark:hover:bg-slate-800/50">
                    <td className="py-2.5 px-4 font-medium">{i.name}</td>
                    <td className="py-2.5 px-4 text-muted-foreground">{i.category}</td>
                    <td className="py-2.5 px-4 font-semibold">{i.stock}</td>
                    <td className="py-2.5 px-4 text-muted-foreground">{i.reorder_level}</td>
                    <td className="py-2.5 px-4">{inr(i.price)}</td>
                    <td className="py-2.5 px-4"><Badge className={cls}>{label}</Badge></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
